import { defineMessages } from 'react-intl';

export const ProfileTranslations = defineMessages({
  backToMarketplace: {
    id: 'ProfileTranslations.backToMarketplace',
    defaultMessage: "Retour à l'accueil",
  },
});
